<template>
  <div class="info">
    <div class="title">聯絡我們</div>
    <div class="contentTop">
      <!-- <p>電子信箱：service@jy-meditech.com</p>
      <p>您也可以在下方留下您的聯繫方式，我們會盡快與您聯繫</p> -->
      <p>請留下您的聯絡方式，我們會盡快與您聯絡</p>
    </div>
    <div class="infoForm">
      <el-form :model="infoform" :rules="rules" ref="infoform" style="max-width: 600px">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="infoform.name" placeholder="請輸入姓名" />
        </el-form-item>
        <el-form-item label="公司名稱" prop="companyName">
          <el-input v-model="infoform.companyName" placeholder="請輸入公司名稱" />
        </el-form-item>
        <el-form-item label="電子信箱" prop="emaril">
          <el-input v-model="infoform.email" placeholder="請輸入電子信箱" />
        </el-form-item>
        <el-form-item label="手機號碼" prop="phoneNumber">
          <div style="display: flex;justify-content: space-around;align-items: center;height: 40px;width: 100%;">
            <el-input v-model="infoform.phoneNumber" placeholder="請輸入手機號碼" @input="handlePNInput" />
            <p :class="isSendVerify ? 'setVerifyClass' : 'setVerifyNumClass'"
              :style="{ 'cursor': isSendVerify ? 'pointer' : '' }" @click="handleSendVerifyCode()">{{ countdown
                <= 0 ? "發送驗證碼" : countdown + "秒" }}</p>
          </div>
        </el-form-item>
        <el-form-item label="驗證碼" prop="verifyCode">
          <el-input v-model="infoform.verifyCode" placeholder="請輸入驗證碼" />
        </el-form-item>
      </el-form>
    </div>
    <div class="btnStyle">
      <div style="width: 100%;display: flex;flex-direction: column;">
        <el-button class="setSubmitBtn" :type="ifSubmitForm ? 'primary' : 'info'" @click="handleSubmit('infoform')">
          提交
        </el-button>
        <el-button style="cursor: pointer;" type="default" @click="handleCancel()">
          取消
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { submitInfo, sendVerityCode, VerityCode, } from '@/api/index1.js'
export default {
  data() {
    return {
      infoform: {
        name: '',
        companyName: '',
        phoneNumber: '',
        email: '',
        verifyCode: "",
      },
      rules: {
        name: [
          // { required: true, message: "請輸入姓名", trigger: "blur" },
          { required: true, validator: this.validateName, trigger: "blur" }
        ],
        phoneNumber: [
          // { required: true, message: "請輸入手機號碼", trigger: "blur" },
          { required: true, validator: this.validateTaiwanPhone, trigger: "blur" }
        ],
        verifyCode: [
          // { required: true, message: "請輸入驗證碼", trigger: "blur" },
          { required: true, validator: this.validateVerifyCode, trigger: "blur" }
        ]
      },
      timer: null,
      countdown: 0,
      errorMsg: false,//验证码错误标记
      errorMsgText: '',
      isSendVerify: false,//判断发送验证码是否为点击状态
    }
  },
  computed: {
    ifSubmitForm() {
      return this.infoform.name && this.infoform.phoneNumber && this.infoform.verifyCode
    }
  },
  methods: {
    handlePNInput(value) {
      if (this.countdown <= 0) {
        let IdRegExpT = /^09\d{8}$/;
        let IdRegExpD = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;

        // 即時控制按鈕狀態，但不觸發 validateField (所以不會有紅字)
        this.isSendVerify = IdRegExpT.test(value) || IdRegExpD.test(value);

        // 如果輸入正確，自動清除紅字提示（增加體驗）
        if (this.isSendVerify) {
          this.$refs['infoform'].clearValidate('phoneNumber');
        }
      }
    },
    async handleSubmit(formName) {
      if (this.ifSubmitForm) {
        const codeData = {
          tel: this.infoform.phoneNumber,
          verifyCode: this.infoform.verifyCode
        }
        const { code, data, msg } = await VerityCode(codeData)
        if (code === 200) {
          this.errorMsg = false
          this.handleSend()
        } else {
          this.errorMsgText = msg
          this.errorMsg = true
          this.$refs[formName].validateField('verifyCode')
        }
      } else {
        this.$message({
          type: 'info',
          message: '請填寫必填欄位',
          offset: 0,
          duration: 5000,
          center: true,
          customClass: 'my-error-message'
        })
      }

    },
    // 送出
    handleSend() {
      this.$refs.infoform.validate(async (valid) => {
        if (valid) {
          const data1 = {
            Uname: this.infoform.name,
            email: this.infoform.email,
            phone: this.infoform.phoneNumber,
            company: this.infoform.companyName,
          };
          const { code, msg } = await submitInfo(data1);
          if (code === 200) {
            this.$refs.infoform.resetFields();
            this.clearForm()
            this.$router.go(-1)

            this.$message({
              type: 'success',
              offset: 0,
              duration: 5000,
              center: true,
              message: '送出成功，我們將盡快與您聯絡',
              customClass: 'my-message'  // 自定义类名
            })
          } else {
            this.$refs.infoform.resetFields();
            this.clearForm()
            this.$router.go(-1)
            this.$message({
              type: 'info',
              message: '送出失敗，請再試一次',
              offset: 0,
              duration: 5000,
              center: true,
              customClass: 'my-error-message'
            })
          }
        } else {
          return false;
        }
      })
    },

    handleCancel() {
      this.$refs.infoform.resetFields()
      this.clearForm()
      this.$router.go(-1)
    },
    // 清空表单
    clearForm() {
      this.infoform.name = '';
      this.infoform.companyName = '';
      this.infoform.phoneNumber = '';
      this.infoform.email = '';
    },

    // 发送验证码
    async handleSendVerifyCode() {
      if (this.isSendVerify) {
        const codeData = {
          tel: this.infoform.phoneNumber,
          from: 'office'
        }
        let { code, data, msg } = await sendVerityCode(codeData)
        if (code === 200) {
          // 开始倒计时 60 秒
          this.countdown = 60;
          this.isSendVerify = false
          this.timer = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
              this.isSendVerify = true
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        } else {
          this.$message({
            type: 'warning',
            message: msg
          });
        }
      } else if (this.countdown === 0) {
        this.$message({
          type: 'info',
          message: '請先填寫手機號碼',
          offset: 0,
          duration: 5000,
          center: true,
          customClass: 'my-error-message'
        })
      }
    },
    // 姓名校验：不允许包含特殊符号，只允许中文、英文、数字和空格
    validateName(rule, value, callback) {
      if (!value) {
        return callback(); // 必填由 required 规则处理
      }
      // 允许中文、英文、数字、空格，禁止特殊符号
      const regex = /^[\u4e00-\u9fa5a-zA-Z0-9\s]+$/;
      if (!regex.test(value)) {
        callback(new Error("不可包含特殊符號"));
      } else {
        callback();
      }
    },

    // 台湾手机号码校验：09开头，长度10位数字
    validateTaiwanPhone(rule, value, callback) {
      if (!value) {
        this.isSendVerify = false;
        return callback(); // 必填由 required 规则处理
      }
      let IdRegExpT = /^09\d{8}$/;
      let IdRegExpD = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (!IdRegExpT.test(value) && !IdRegExpD.test(value)) {
        this.isSendVerify = false;
        callback(new Error("手機號碼格式錯誤"));
      } else {
        this.canSend = true
        this.isSendVerify = true;
        callback();
      }
    },
    // 验证验证码
    validateVerifyCode(rule, value, callback) {
      if (!value) {
        return callback(); // 必填由 required 规则处理
      }
      if (this.errorMsg) {
        return callback(new Error(this.errorMsgText));
      }
      callback();
    }
  }
}
</script>

<style lang="less">
.info {
  position: relative;
  .title {
    height: 60px;
    line-height: 60px;
    background: #0052A4;
    color: #ffffff;
    font-size: 18px;
    font-weight: 500;
    font-family: Noto Sans CJK TC;
  }

  .contentTop {
    text-align: left;
    margin: 20px 20px 28px 20px;

    p {
      font-size: 16px;
      font-weight: 400;
      font-family: Noto Sans CJK TC;
      color: #333333;
      height: 26px;
      line-height: 26px;
    }
  }

  .infoForm {
    margin: 0 20px 116px 20px;

    .el-form {
      .el-form-item {
        display: flex !important;
        flex-direction: column !important;
        margin-bottom: 24px !important;

        .el-form-item__error {
          // top: 120%;
          position: relative !important;
          padding-top: 8px !important;
          font-family: Noto Sans CJK TC;
          font-weight: 400;
          font-size: 14px;
          color: #EB5757;
        }

        .el-form-item__error {
          top: 130%;
        }

        .el-input--small {
          height: 40px !important;

          .el-input__inner {
            height: 40px;
            line-height: 40px;
            padding: 10px 12px;
            border-radius: 8px;
            border: 1px solid #C8C6C9;
            font-size: 16px;
            font-weight: 400;
            color: #333333;
            caret-color: #0052A4;
          }

          .el-input__inner:focus,
          .el-input__inner:hover {
            border-color: #0052A4;
          }
        }

        .el-form-item__label {
          width: 100px !important;
          display: inline !important;
          font-weight: 400 !important;
          font-size: 16px;
          color: #333333;
          text-align: left;
          height: 16px;
          line-height: 16px;
        }

        .el-form-item__content {
          padding-top: 8px !important;
        }
      }

      .setVerifyClass,
      .setVerifyNumClass {
        width: 120px;
        height: 40px;
        line-height: 40px;
        border-radius: 8px;
        margin-left: 8px;
        padding: 0 21.35px;
        word-break: keep-all;
        font-family: Noto Sans CJK TC;
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
      }

      .setVerifyClass {
        background-color: #EF7F1B;
      }

      .setVerifyNumClass {
        background-color: #828282;
      }

    }
  }

}

.messageTipsStyle {
  top: 40% !important;
}

.el-message {

  i {
    display: none;
  }
}

.my-message,
.my-error-message {
  width: 100% !important;
  height: 70px !important;
  padding: 16px 40px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
  border-color: transparent !important;
}

.my-message {
  background-color: #D7F0FF !important;
}

.my-message .el-message__content,
.my-error-message .el-message__content {
  font-family: Noto Sans CJK TC;
  font-size: 16px;
  font-weight: 500;
  color: #444444 !important;
}

.my-message .el-message__icon {
  display: inline-block;
  color: transparent !important;
  background-image: url("../assets/icon/successIcon.png");
  background-size: 36px;
  width: 36px;
  height: 36px;
}

.my-error-message {
  background-color: #FFE9D6 !important;
}

.my-error-message .el-message__icon {
  display: inline-block;
  color: transparent !important;
  background-image: url("../assets/icon/warmIcon.png");
  background-size: 36px;
  width: 36px;
  height: 36px;
}

.btnStyle {
  // margin: 0 20px;
  width: calc(100% - 40px);
  margin: 0px auto 28px auto;
  position: relative;
  // bottom: 28px;
  // left: 20px;

  .el-button {
    width: 100% !important;
    height: 53px;
    border-radius: 8px;
    font-size: 18px;
    font-weight: 500;
    margin-left: 0;
  }

  .el-button--primary {
    background-color: #0052a4 !important;
  }

  .setSubmitBtn {
    width: 100%;
    height: 53px;
    border-radius: 8px;
    cursor: pointer;
    border: 0;
  }

  .el-button--info {
    width: 100%;
    height: 53px;
    border-radius: 8px;
    background-color: #828282 !important;
    border: 0;
  }

  .el-button--default {
    border: 1px solid #828282 !important;
    color: #828282;
    margin-top: 12px;
    margin-left: 0 !important;
  }

  .el-button--default:hover,
  .el-button--default:focus,
  .el-button--default:active {
    border: 1px solid #828282 !important;
    background: #ffffff;
    color: #828282;
  }
}

.el-form-item.is-error .el-input__inner,
.el-form-item.is-error .el-input__inner:focus,
.el-form-item.is-error .el-select-v2__wrapper,
.el-form-item.is-error .el-select-v2__wrapper:focus,
.el-form-item.is-error .el-textarea__inner,
.el-form-item.is-error .el-textarea__inner:focus {
  border-color: #EB5757 !important;
}
</style>